import { render, staticRenderFns } from "./viewPurchasesReturn.vue?vue&type=template&id=706c1ea7&scoped=true&"
import script from "./viewPurchasesReturn.vue?vue&type=script&lang=js&"
export * from "./viewPurchasesReturn.vue?vue&type=script&lang=js&"
import style0 from "./viewPurchasesReturn.vue?vue&type=style&index=0&id=706c1ea7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706c1ea7",
  null
  
)

export default component.exports